import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const PROCESS_INSTANCE_LOADED = NS + 'PROCESS_INSTANCE_LOADED'

export const FIND_PROCESS_INSTANCE_REQUEST = NS + 'FIND_PROCESS_INSTANCE_REQUEST'
export const FIND_PROCESS_INSTANCE_SUCCESS = NS + 'FIND_PROCESS_INSTANCE_SUCCESS'
export const FIND_PROCESS_INSTANCE_ERROR = NS + 'FIND_PROCESS_INSTANCE_ERROR'


export const TOGGLE_PROCESS_FLOW_VISIBILITY = NS + 'TOGGLE_PROCESS_FLOW_VISIBILITY'


export const TOGGLE_VIP_STATUS_REQUEST = NS + 'TOGGLE_VIP_STATUS_REQUEST'
export const TOGGLE_VIP_STATUS_SUCCESS = NS + 'TOGGLE_VIP_STATUS_SUCCESS'
export const TOGGLE_VIP_STATUS_ERROR = NS + 'TOGGLE_VIP_STATUS_ERROR'

export const TOGGLE_RUSH_STATUS_REQUEST = NS + 'TOGGLE_RUSH_STATUS_REQUEST'
export const TOGGLE_RUSH_STATUS_SUCCESS = NS + 'TOGGLE_RUSH_STATUS_SUCCESS'
export const TOGGLE_RUSH_STATUS_ERROR = NS + 'TOGGLE_RUSH_STATUS_ERROR'

export const CHANGE_PROCESS_COMMENT = NS + 'CHANGE_PROCESS_COMMENT'

export const COMMENT_PROCESS_INSTANCE_REQUEST = NS + 'COMMENT_PROCESS_INSTANCE_REQUEST'
export const COMMENT_PROCESS_INSTANCE_SUCCESS = NS + 'COMMENT_PROCESS_INSTANCE_SUCCESS'
export const COMMENT_PROCESS_INSTANCE_ERROR = NS + 'COMMENT_PROCESS_INSTANCE_ERROR'


export const CHANGE_PROCESS_CONTEXT = NS + 'CHANGE_PROCESS_CONTEXT'

export const SAVE_PROCESS_CONTEXT_REQUEST = NS + 'SAVE_PROCESS_CONTEXT_REQUEST'
export const SAVE_PROCESS_CONTEXT_SUCCESS = NS + 'SAVE_PROCESS_CONTEXT_SUCCESS'
export const SAVE_PROCESS_CONTEXT_ERROR = NS + 'SAVE_PROCESS_CONTEXT_ERROR'


export const SET_VALIDATION_MESSAGE_LIST = NS + 'SET_VALIDATION_MESSAGE_LIST'

export const FIRE_EVENT_REQUEST = NS + 'FIRE_EVENT_REQUEST'
export const FIRE_EVENT_SUCCESS = NS + 'FIRE_EVENT_SUCCESS'
export const FIRE_EVENT_ERROR = NS + 'FIRE_EVENT_ERROR'


export const CHANGE_TIME_REQUEST = NS + 'CHANGE_TIME_REQUEST'
export const CHANGE_TIME_SUCCESS = NS + 'CHANGE_TIME_SUCCESS'
export const CHANGE_TIME_ERROR = NS + 'CHANGE_TIME_ERROR'


export const CHANGE_BEAM_PROCESS_STATE = NS + 'CHANGE_BEAM_PROCESS_STATE'

export const BEAM_PROCESS_INSTANCE_REQUEST = NS + 'BEAM_PROCESS_INSTANCE_REQUEST'
export const BEAM_PROCESS_INSTANCE_SUCCESS = NS + 'BEAM_PROCESS_INSTANCE_SUCCESS'
export const BEAM_PROCESS_INSTANCE_ERROR = NS + 'BEAM_PROCESS_INSTANCE_ERROR'



// WEBPACK FOOTER //
// ./src/modules/process/state/instance-detail/type.js